import { useAuth0 } from "@auth0/auth0-react";
import { DatePickerField } from "_metronic/_partials/controls";
import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
import { HintField, InputField, LabelField, SelectField } from "components";
import { TextareaField } from "components/TextareaField";
import { getDateFormat, getDateFormatForDatePicket, maskDate } from "helper/dateFormat";
import { getCurrency } from "helper/numberFormat";
import { useSearch } from "hook";
import FinanceService from "Lib/API/Finance";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toastr } from "react-redux-toastr";
import Select, { components } from "react-select";
import MaskedInput from "react-text-mask";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
import AddInstallmentsPayment from "../../../../components/Installments/AddInstallmentsPayment";
import { MyCheckbox } from "../../../../components/MyCheckbox";
import InfoTooltip from "../../../../components/InfoTooltip";
import { PriceType } from "../../NewCharge/ChargeType/PercentageFixed";

const Manual = ({ types, setShow, show, formik, enableInstallments }) => {
  const [search, setSearch] = useState("");
  const { getAccessTokenSilently } = useAuth0();
  const [loading, setLoading] = useState(false);
  const { searchAction } = useSearch({ action: setSearch });
  const [ledgers, setLedgers] = useState();
  const [localFormat, setLocalFormat] = useState(false);
  const [taxType, setTaxType] = useState("%");
  const [discountType, setDiscountType] = useState("%");

  const dateMask = maskDate();
  const placeholderFormat = getDateFormat();
  const dateFormat = getDateFormatForDatePicket();
  const currency = getCurrency();
  const autoCorrectedDatePipe = createAutoCorrectedDatePipe(dateFormat || "mm/dd/yyyy");



  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <BottomArrowSvg label="Emoji" />
      </components.DropdownIndicator>
    );
  };
  const selectControlStyles = {
    backgroundColor: "#F3F6F9",
    borderColor: "#F3F6F9",
    color: "#3F4254",
    transition:
      "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
    paddingTop: "6px",
    paddingBottom: "6px",
    cursor: "pointer",
  };

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      ...selectControlStyles,
    }),
  };
  const exceptThisSymbols = ["e", "E", "+", "-"];
  const preventArrows = (e) => {
    if (e.which === 38 || e.which === 40 || exceptThisSymbols.includes(e.key))
      e.preventDefault();
  };
  const formatOptionLabel = ({ label, _id }) => {
    return (
      <div className="dropdown-container" key={_id}>
        <div className="icon-name-container d-flex align-items-center justify-content-start">
          <div className="name-container" style={{ marginInlineStart: 10 }}>
            <div>{label}</div>
          </div>
        </div>
      </div>
    );
  };

  const getSubledgerList = ledgers?.find(
    (x) => x._id === formik?.values?.Ledger?.id
  );
  // Get Ledger Subledger List
  const fetchLedgerSubledgerList = async () => {
    const token = await getAccessTokenSilently();
    await FinanceService.getLedgerSubLedgerList(token)
      .then((res) => {
        setLedgers(res?.ledgers);
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);
      });
  };
  useEffect(() => {
    fetchLedgerSubledgerList();
    if (formik?.values.nextpayment === false) {
      formik.setFieldValue(`batch_name`, "");
      formik.setFieldValue(`description`, "");
      formik.setFieldValue(`Ledger`, {
        name: "",
        id: "",
      });
      formik.setFieldValue(`SubLedger`, {
        name: "",
        id: "",
      });
      formik.setFieldValue(`amount`, "");
      formik.setFieldValue(`discount`, "");
      formik.setFieldValue(`tax`, "");
      formik.setFieldValue(`require_notes`, false);
      formik.setFieldValue(`note`, "");
      formik.setFieldValue(`is_splitted`, false);
      formik.setFieldValue(`split_duration`, "");
      formik.setFieldValue(`split_amount`, "");
      formik.setFieldValue("due_date", "");
    }
  }, []);
  const subLegderOptions = getSubledgerList?.sub_ledgers?.map((item) => {
    return {
      label: item?.sub_ledger_name,
      value: item?._id,
      amount: item?.default_amount,
      notes: item?.notes,
    };
  });
  const legderOptions = ledgers?.map((item) => {
    return {
      label: item?.ledger_name,
      value: item?._id,
      amount: item?.default_amount,
      notes: item?.notes,
    };
  });
  useEffect(() => {
    formik.setFieldValue(`batch_type`, show?.toLowerCase());
  }, [show]);
  const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;

  const getSubLedgerOnChange = async (event) => {
    if (!event) {
      formik.setFieldValue(`SubLedger`, {
        id: "",
        name: "",
      });
      const currentLedger = legderOptions.find(
        (item) => item.value === formik.values?.Ledger?.id
      );
      if (currentLedger) {
        formik.setFieldValue(`amount`, currentLedger.amount);
        formik.setFieldValue(`require_notes`, currentLedger.notes);
      }
      return;
    }
    formik.setFieldValue(`SubLedger`, {
      id: event.value,
      name: event.label,
    });
    formik.setFieldValue(`amount`, event?.amount);
    formik.setFieldValue(`require_notes`, event?.notes);

    //  formik.setFieldValue(`amount`, event?.default_amount);

    //  //  formik.setFieldValue(`amount`, );
    //  const current = legderOptions.find(
    //    (item) => item.options.indexOf(event) !== -1
    //  );
    //  if (current) {
    //    formik.setFieldValue(`Ledger`, {
    //      id: current.value,
    //      name: current.label,
    //    });
    //    formik.setFieldValue(`amount`, current.options[0]?.amount);
    //  }
  };
  const getLedgerOnChange = async (event) => {
    // formik.setFieldValue(`SubLedger`, {
    //   id: event.value,
    //   name: event.label,
    // });
    // formik.setFieldValue(`amount`, event?.default_amount);

    // //  formik.setFieldValue(`amount`, );
    // const current = legderOptions.find(
    //   (item) => item.options.indexOf(event) !== -1
    // );
    // if (current) {
    formik.setFieldValue(`Ledger`, {
      id: event?.value,
      name: event?.label,
    });
    formik.setFieldValue(`SubLedger`, "");
    formik.setFieldValue(`amount`, event?.amount);
    formik.setFieldValue(`require_notes`, event?.notes);
  };


  function convertUTCToLocalDate(date) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate()
    );
    return date;
  }
  function convertLocalToUTCDate(date, name) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
    );
    formik.setFieldValue(name, date);
    return date;
  }

  useEffect(() => {
    if (formik.values?.discount_type === "%" && formik.values?.discount >= 100) {
      toastr.error("Validation", "discount should be less than 100%")
      formik.setFieldValue("discount", 0)
    }
  }, [formik.values?.discount_type])

  // useEffect(() => {
  //   if (formik.values.amount < formik.values.discount && formik.values?.discount_type === "$") {
  //     formik.setFieldValue(
  //       `discount`,
  //       0
  //     );
  //     toastr.error("Validation", "Discount should be less than amount");
  //   }

  // }, [formik.values])

  const handleDiscountValue = (e) => {
    const data = formik.values?.amount;
    if (formik.values?.discount_type === "%") {
      if (e.target.value < 100) {
        formik.setFieldValue(
          `discount`,
          e.target.value.match(regex)[0]
        );
      } else {
        formik.setFieldValue(
          `discount`,
          0
        );
        toastr.error("Validation", "Discount should be less than 100 %");
      }
    } else {
      if (e.target.value < Number(data)) {
        formik.setFieldValue(
          `discount`,
          e.target.value.match(regex)[0]
        );
      } else {
        formik.setFieldValue(
          `discount`,
          0
        );
        toastr.error("Validation", "Discount should be less than amount");
      }
    }
  };

  return (
    <div className="batch-render-comp renderd-comp">
      <form className="form fv-plugins-bootstrap fv-plugins-framework">
        <div className="col-sm-12 px-sm-18 px-3 pt-10 pb-3 ">
          <Row className="form-row sm-12 mb-4">
            <Col className="col-12 col-md-8">
              <div className="form-group batch-input-border">
                <InputField
                  mandatory
                  type="text"
                  {...{
                    formik,
                    title: "Bulk Billing",
                    name: `batch_name`,
                    placeholder: "Batch Name",
                    checkValidation: true,
                    value: formik.values?.batch_name,
                  }}
                  error={formik?.errors["batch_name"]}
                  style={{
                    backgroundColor: "#F3F6F9",
                  }}
                />
              </div>
            </Col>
            <Col className="col-12 col-md-4 charge-tab">
              <div className="form-group">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <LabelField title="Amount Source" />
                  <InfoTooltip text="Manual = enter amounts yourself. Account = pull amounts from account records. Previous Amount = re-bill past charges matching your filters. File = upload a spreadsheet of amounts." style={{ marginLeft: '6px', marginBottom: '8px' }} />
                </div>
                <div className="charge-type">
                  {types?.map((type, idx) => (
                    <span
                      className={
                        type === "Previous Amount" ? "col-sm-3" : "col-sm-3"
                      }
                      style={
                        type === show
                          ? { background: "#2555ef", color: "white" }
                          : {}
                      }
                      key={idx}
                      onClick={() => {
                        setShow(type);
                        formik.setFieldValue("batch_type", show?.toLowerCase());
                      }}
                      {...{
                        formik,
                        name: `batch_type`,
                        value: formik.values?.batch_type,
                      }}
                    >
                      {type}
                    </span>
                  ))}
                </div>
              </div>
            </Col>
          </Row>
          <Row className="form-row sm-12 mb-4">
            <Col className="col-12 col-md-12">
              <div className="form-group">
                <InputField
                  // mandatory
                  type="text"
                  {...{
                    formik,
                    title:
                      "Charge Description (will show on the member statement)",
                    name: `description`,
                    placeholder: "",
                    checkValidation: true,
                    value: formik.values?.description,
                  }}
                  style={{
                    backgroundColor: "#F3F6F9",
                  }}
                />
              </div>
            </Col>
          </Row>
          <Row className="form-row sm-12 mb-4 justify-content-start">
            <Col className="col-12 col-md-4 charge-tab">
              <div
                className="form-group"
                style={{
                  zIndex: "1111",
                }}
              >
                <LabelField mandatory title={"Ledger Account"} />
                <Select
                  mandatory={true}
                  {...{
                    formik,
                    name: `Ledger`,
                    touched: "Ledger",
                    checkValidation: false,
                  }}
                  onInputChange={(text) => searchAction(text)}
                  classNamePrefix="react-select"
                  formatOptionLabel={formatOptionLabel}
                  options={legderOptions}
                  isLoading={loading}
                  styles={colourStyles}
                  onChange={getLedgerOnChange}
                  value={{
                    label: formik.values?.Ledger?.name,
                    value: formik.values?.Ledger?.id,
                  }}
                  components={{ DropdownIndicator }}
                />
                {formik?.values["batchSubmit"] && formik?.errors["Ledger"] ? (
                  <HintField error={formik?.errors["Ledger"]} />
                ) : null}
              </div>
            </Col>
            <Col className="col-12 col-md-4 charge-tab">
              <div className="form-group">
                <LabelField title={"Sub-Ledger Account"} />
                <Select
                  {...{
                    formik,
                    name: `SubLedger`,
                    checkValidation: false,
                  }}
                  isClearable={formik.values?.SubLedger?.id ?? false}
                  onInputChange={(text) => searchAction(text)}
                  classNamePrefix="react-select"
                  formatOptionLabel={formatOptionLabel}
                  options={subLegderOptions}
                  isLoading={loading}
                  styles={colourStyles}
                  onChange={getSubLedgerOnChange}
                  value={{
                    label: formik.values?.SubLedger?.name,
                    value: formik.values?.SubLedger?.id,
                  }}
                  components={{ DropdownIndicator }}
                />
                {formik?.touched["SubLedger"] && formik?.errors["SubLedger"] ? (
                  <HintField error={formik?.errors["SubLedger"]} />
                ) : null}
              </div>
            </Col>
          </Row>
          <Row className="form-row sm-12 mb-4">
            <Col className="col-12 col-md-4">
              <div className="form-group position-relative">
                <InputField
                  mandatory
                  type="number"
                  error={formik?.errors["amount"]}
                  {...{
                    formik,
                    title: "Amount",
                    name: `amount`,
                    placeholder: "Amount",
                    value: formik.values?.amount,
                    checkValidation: true,
                    placeholderIcon: (
                      <span className="amount-placeholder-icon">{currency}</span>
                    ),
                  }}
                  handleChange={(e) => {
                    formik.setFieldValue(
                      `amount`,
                      e.target.value.match(regex)[0]
                    );
                  }}
                  onKeyDown={(e) => preventArrows(e)}
                  min="0"
                  style={{
                    border: "none",
                    backgroundColor: "#F3F6F9",
                  }}
                />
              </div>
            </Col>
            <Col className="col-12 col-md-4 d-flex justify-content-center">
              <Col className="col-sm-6 px-0">
                <div className="form-group">
                  <InputField
                    type="number"
                    {...{
                      formik,
                      title: "Discount",
                      hint: "Reduce the charge amount for this batch, either as a flat amount or a percentage.",
                      name: `discount`,
                      placeholderIcon: (
                        <span className="placeholder-icon">
                          {/* {"$"} */}
                          {formik.values?.discount_type === "%"
                            ? "%"
                            : currency}
                        </span>
                      ),
                      placeholder: "Discount",
                      value: formik.values?.discount,
                      //   ? formik.values?.values?.[index]?.tax
                      //   : formik?.values?.allData
                      //     ? Math.round(formik.values?.values?.[index]?.tax * 1e2) /
                      //     1e2
                      //     : "",
                      checkValidation: true,
                    }}
                    onKeyDown={(e) => preventArrows(e)}
                    style={{
                      backgroundColor: "#F3F6F9",
                      border: "none",
                    }}
                    min="0"
                    handleChange={(e) => {
                      handleDiscountValue(e);
                    }}
                  />
                </div>
              </Col>
              <Col className="col-auto price-type mt-9">
                <PriceType
                  value={discountType}
                  handleClick={setDiscountType}
                  setFieldValue={formik.setFieldValue}
                  type={`discount_type`}
                />
              </Col>
            </Col>
            <Col className="col-12 col-md-4 d-flex justify-content-center">
              <Col className="col-sm-6 px-0">
                <div className="form-group">
                  <InputField
                    type="number"
                    {...{
                      formik,
                      title: "Tax Deductible",
                      hint: "How much of this charge counts as tax-deductible, either as a flat amount or a percentage. Used for donation receipts.",
                      name: `tax`,
                      placeholderIcon: (
                        <span className="placeholder-icon">
                          {/* {"$"} */}
                          {formik.values?.tax_type === "%"
                            ? "%"
                            : currency}
                        </span>
                      ),
                      placeholder: "Tax",
                      value: formik.values?.tax,
                      //   ? formik.values?.values?.[index]?.tax
                      //   : formik?.values?.allData
                      //     ? Math.round(formik.values?.values?.[index]?.tax * 1e2) /
                      //     1e2
                      //     : "",
                      checkValidation: true,
                    }}
                    onKeyDown={(e) => preventArrows(e)}
                    style={{
                      backgroundColor: "#F3F6F9",
                      border: "none",
                    }}
                    min="0"
                    onChange={(e) => {
                      formik.setFieldValue(`tax`, e);
                    }}
                  />
                </div>
              </Col>
              <Col className="col-auto price-type mt-9">
                <PriceType
                  value={formik.values?.tax_type}
                  handleClick={setTaxType}
                  setFieldValue={formik.setFieldValue}
                  type={`tax_type`}
                />
              </Col>
            </Col>
          </Row>
          <Row className="form-row sm-12 mb-4 justify-content-start">
            <Col className="col-12 col-md-4 charge-tab batch-date_picker">
              <div className="form-group showDatePicker">
                <LabelField title={"Charge Date"} mandatory />
                <DatePicker
                  // isClearable
                  // disabled={true}
                  showIcon
                  placeholderText={placeholderFormat}
                  dateFormat={dateFormat}
                  selected={
                    formik.values?.charge_date &&
                    convertUTCToLocalDate(formik.values?.charge_date)
                  }
                  onChange={(e) => {
                    formik.setFieldValue(`charge_date`, convertLocalToUTCDate(e));
                  }}
                />
              </div>
            </Col>
            <Col className="col-12 col-md-4 charge-tab batch-date_picker">
              <div className="form-group">
                <LabelField title={"Due Date"} mandatory />
                <DatePicker
                  isClearable
                  showIcon
                  placeholderText={placeholderFormat}
                  dateFormat={dateFormat}
                  minDate={convertUTCToLocalDate(formik.values?.charge_date)}
                  selected={
                    formik.values?.due_date &&
                    convertUTCToLocalDate(formik.values?.due_date)
                  }
                  onChange={(e) => {
                    formik.setFieldValue(`due_date`, convertLocalToUTCDate(e));
                  }}
                  customInput={
                    <MaskedInput
                      pipe={autoCorrectedDatePipe}
                      mask={dateMask}
                      keepCharPositions={true}
                      guide={true}
                    />
                  }
                />
              </div>

            </Col>
          </Row>
          <Col className="col mb-10 px-0">
            <div
              className="d-flex align-items-center"
              style={{
                gap: "2rem",
              }}
            >
              <div
                className=""
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <MyCheckbox
                  name={`is_splitted`}
                  split_amount
                  title="Split"
                  handlechange={(event) => {
                    formik.setFieldValue(
                      `is_splitted`,
                      event.target.checked
                    );
                    formik.setFieldValue(`isInstallmentTransaction`, false);
                    formik.setFieldValue(`installmentDetailsTransaction`, undefined);
                  }}
                  value={formik.values?.is_splitted}
                  checked={formik.values?.is_splitted}
                />
                <InfoTooltip text={<>Break this batch <b>charge</b> into multiple payments spread over time, instead of billing the full amount at once.</>} style={{ marginLeft: '6px', marginBottom: '8px' }} />
              </div>
              {enableInstallments && (
                <div
                  className=""
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <MyCheckbox
                    name={`isInstallmentTransaction`}
                    split_amount
                    title="Allow Installments"
                    handlechange={(event) => {
                      formik.setFieldValue(
                        `isInstallmentTransaction`,
                        event.target.checked
                      );
                      formik.setFieldValue(`is_splitted`, false);
                    }}
                    value={formik.values?.isInstallmentTransaction}
                    checked={formik.values?.isInstallmentTransaction}
                  />
                  <InfoTooltip text="Let the payer spread this batch charge across multiple scheduled installments instead of paying it all at once." style={{ marginLeft: '6px', marginBottom: '8px' }} />
                </div>
              )}
            </div>
            {(formik.values?.isInstallmentTransaction && enableInstallments) && (
              <AddInstallmentsPayment
                formik={formik}
                formikKey="installmentDetailsTransaction"
              />
            )}
            {formik.values?.is_splitted && (
              <Row>
                <div className="col-sm-5 col-md-4">
                  <SelectField
                    {...{
                      formik,
                      name: `split_duration`,
                      items: ["day", "week", "month", "quarter", "year"],
                      placeholder: "Select",
                      value: formik.values?.split_duration ? (
                        <span style={{ color: "black" }}>
                          {formik.values?.split_duration}
                        </span>
                      ) : (
                        "Select"
                      ),
                    }}
                    onClick={(data) =>
                      formik.setFieldValue(
                        `split_duration`,
                        data
                      )
                    }
                  />
                </div>
                {formik.values?.split_duration ? (
                  <div className="col-sm-3">
                    <InputField
                      type="number"
                      {...{
                        formik,
                        title: "",
                        name: `number_of_split`,
                        placeholder: "0",
                        value: formik.values?.number_of_split,
                        checkValidation: true,
                      }}
                      onKeyDown={(e) => preventArrows(e)}
                      handleChange={(e) => {
                        const newValue = parseInt(e.target.value);
                        formik.setFieldValue(
                          `number_of_split`,
                          newValue
                        );
                      }}
                    />
                    <div className="placeholder-div">
                      <p>{formik.values?.split_amount}</p>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </Row>
            )}
          </Col>
          <Row className="form-row sm-12 mb-0">
            <Col className="col-sm-12 px-0">
              <TextareaField
                mandatory={formik?.values?.require_notes ? true : false}
                {...{
                  formik,
                  title: "Add Note",
                  name: `note`,
                  placeholder: "Note text",
                  style: { resize: "none" },
                  checkValidation: true,
                  onChange: (value) => {
                    formik.setFieldValue(`note`, value);
                  },
                }}
                defaultValue={
                  formik?.values?.note
                }
              />
            </Col>
          </Row>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <MyCheckbox
              {...{
                formik,
                title: "Add Note",
                name: `comment_checkbox`,
              }}
              // disabled={formik.values.type === "edit-charge" ? true : false}
              title="Comment on invoice"
              handleSubmit
              handlechange={(event) => {
                formik.setFieldValue(
                  `comment_checkbox`,
                  event.target.checked
                );
              }}
              checked={formik?.values?.comment_checkbox}
            />
            <InfoTooltip text="Show the note above on the invoice sent to the payer, instead of keeping it internal only." style={{ marginLeft: '6px', marginBottom: '8px' }} />
          </div>
        </div>
      </form>
    </div>
  );
};

export default Manual;
